import styled from "styled-components";
export const Styles = styled.div`
  #aboutUsSection {
    position: relative;
    margin-top:80px
  }
  #aboutUsSection .react-img {
    position: absolute;
    height: 50%;
    top: -100px;
    left: -180px;
  }
  #aboutUsSection .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  #aboutUsSection .container .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
  }
  #aboutUsSection .section-title{
    margin-bottom:20px
  }
  #aboutUsSection .about-img {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }
  #aboutUsSection .about-img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  #aboutUsSection .about-img .btn-primary {
    padding-inline: 60px;
    font-size: 16px;
    margin-top: -20px !important;
  }
  #aboutUsSection .about-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
  }
  #aboutUsSection .about-container .about-item {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    width: 100%;
    margin-bottom: 20px;
  }
  #aboutUsSection .about-container .about-item .item-number {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-inline-end: 20px;
  }
  #aboutUsSection .about-container .about-item .item-number .number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 20px;
    color: #fff;
  }
  #aboutUsSection .about-container .about-item:nth-child(3n+2) .item-number .number {
    background: #20c4f4;
  }
  #aboutUsSection .about-container .about-item:nth-child(3n+3) .item-number .number {
    background: var(--dark-color);
  }
  #aboutUsSection .about-container .about-item:nth-child(3n+1) .item-number .number {
    background: var(--dark-purple);
  }
  #aboutUsSection
    .about-container
    .about-item:not(:last-child)
    .item-number
    .line {
    width: 1px;
    height: 50px;
    background: #bcbcbc;
  }
  
  #aboutUsSection .about-container .about-item .item-data {
    margin-top: 5px;
    width: 100%;
  }
  #aboutUsSection .about-container .about-item .item-data .item-title {
    font-size: 18px;
    margin-bottom: 5px;
    color: var(--dark-purple);
  }
  #aboutUsSection .about-container .about-item .item-data .item-description {
    font-size: 15px;
    color: var(--dark-color);
  }
  @media (max-width: 1080px) {
    #aboutUsSection .react-img {
      height: 40%;
    }
  }
  @media (max-width: 768px) {
    #aboutUsSection .react-img {
      height: 25%;
      left: -120px;
    }
    #aboutUsSection .about-container {
      margin-top: 20px;
    }
    #aboutUsSection .about-container .about-item {
      align-items: center;
      justify-content: center;
      text-align: center;
      flex-direction: column;
    }
    #aboutUsSection .about-container .about-item .item-number {
      margin-inline-end: 0;
    }
    #aboutUsSection .about-container .about-item .item-number .line {
      display: none;
    }
    #aboutUsSection .about-container .about-item .item-data {
      margin-top: 0;
    }
  }
`;
